import { render } from "./Safety.vue?vue&type=template&id=dfbc4284&scoped=true"
import script from "./Safety.vue?vue&type=script&lang=js"
export * from "./Safety.vue?vue&type=script&lang=js"

import "./Safety.vue?vue&type=style&index=0&id=dfbc4284&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfbc4284"]])

export default __exports__